import { TimesheetTableProps } from '../types/timesheet';
import TimesheetRow from './TimesheetRow';
import { Box, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';

export default function TimesheetTable({
  rows,
  updateRowField,
  updateHours,
  removeRow,
  weekDates,
  weekDays,
  disabled,
}: TimesheetTableProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Mobile-friendly card layout
  if (isMobile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {rows.map((row, rowIndex) => (
          <TimesheetRow
            key={rowIndex}
            row={row}
            rowIndex={rowIndex}
            updateRowField={updateRowField}
            updateHours={updateHours}
            removeRow={removeRow}
            showRemove={rows.length > 1}
            disabled={disabled}
            weekDates={weekDates}
            weekDays={weekDays}
            isMobile={true}
          />
        ))}
      </Box>
    );
  }

  // Desktop table layout
  return (
    <Box>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={3}>
          <Typography variant="subtitle2">Task / Notes</Typography>
        </Grid>
        {weekDates.map((date, i) => (
          <Grid item xs={1} key={i} sx={{ textAlign: 'center' }}>
            <Box>
              <Typography variant="subtitle2">{date}</Typography>
              <Typography variant="caption" color="text.secondary">
                {weekDays[i]}
              </Typography>
            </Box>
          </Grid>
        ))}
        <Grid item xs={1} sx={{ textAlign: 'center' }}>
          <Typography variant="subtitle2">Total</Typography>
        </Grid>
        <Grid item xs={1} />
      </Grid>

      {rows.map((row, rowIndex) => (
        <TimesheetRow
          key={rowIndex}
          row={row}
          rowIndex={rowIndex}
          updateRowField={updateRowField}
          updateHours={updateHours}
          removeRow={removeRow}
          showRemove={rows.length > 1}
          disabled={disabled}
        />
      ))}
    </Box>
  );
}
